import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';
//import logoEsg from '../../public/Logo_or.png';

// ─── Login ────────────────────────────────────────────────────────────────────
export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      if (user.role === 'user') {
        navigate(user.hasCompany ? '/dashboard' : '/setup');
      } else {
        navigate('/admin');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Errore di accesso');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page" style={{minHeight: 800}}>
      <div className="auth-card" >
        <div className="auth-logo">
          <img src='/Logo_or.png' alt='logoEsg' />
          {/* <div className="auth-logo-circle">E</div> */}
          <h1>Accedi a ESGcert</h1>
          <p>Inserisci le tue credenziali per continuare</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input className="form-control" type="email" required placeholder="email@azienda.it"
              value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input className="form-control" type="password" required placeholder="••••••••"
              value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} />
          </div>
          <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: 4 }} disabled={loading}>
            {loading ? 'Accesso in corso...' : 'Accedi'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14, color: '#5C5B55' }}>
          Non hai un account? <Link to="/register">Registrati</Link>
        </p>
      </div>
    </div>
  );
}

// ─── Register ─────────────────────────────────────────────────────────────────
export function RegisterPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) { toast.error('Le password non corrispondono'); return; }
    if (form.password.length < 8) { toast.error('La password deve essere di almeno 8 caratteri'); return; }
    setLoading(true);
    try {
      await axios.post('/api/auth/register', { email: form.email, password: form.password });
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Errore di registrazione');
    } finally {
      setLoading(false);
    }
  };

  if (done) return (
    <div className="auth-page">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>📧</div>
        <h1 style={{ marginBottom: 10 }}>Controlla la tua email</h1>
        <p>Abbiamo inviato un link di verifica a <strong>{form.email}</strong>. Clicca il link per attivare il tuo account.</p>
        <Link to="/login" className="btn btn-primary" style={{ marginTop: 24, justifyContent: 'center', width: '100%' }}>Vai al login</Link>
      </div>
    </div>
  );

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <img src='/Logo_or.png' alt='logoEsg' />
          <h1>Crea il tuo account</h1>
          <p>Inizia il tuo percorso di certificazione ESG</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email aziendale</label>
            <input className="form-control" type="email" required placeholder="email@azienda.it"
              value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input className="form-control" type="password" required placeholder="Minimo 8 caratteri"
              value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} />
          </div>
          <div className="form-group">
            <label>Conferma password</label>
            <input className="form-control" type="password" required placeholder="Ripeti la password"
              value={form.confirm} onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))} />
          </div>
          <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
            {loading ? 'Registrazione...' : 'Crea account'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14, color: '#5C5B55' }}>
          Hai già un account? <Link to="/login">Accedi</Link>
        </p>
      </div>
    </div>
  );
}

// ─── Verify Email ─────────────────────────────────────────────────────────────
export function VerifyEmailPage() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');

  React.useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token');
    if (!token) { setStatus('error'); return; }
    axios.post('/api/auth/verify-email', { token })
      .then(() => { setStatus('success'); setTimeout(() => navigate('/login'), 2500); })
      .catch(() => setStatus('error'));
  }, [navigate]);

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        {status === 'verifying' && <><div style={{ fontSize: 48, marginBottom: 16 }}>⏳</div><h1>Verifica in corso...</h1></>}
        {status === 'success' && <><div style={{ fontSize: 48, marginBottom: 16 }}>✅</div><h1>Email verificata!</h1><p style={{ marginTop: 8 }}>Verrai reindirizzato al login...</p></>}
        {status === 'error' && <><div style={{ fontSize: 48, marginBottom: 16 }}>❌</div><h1>Link non valido</h1><p style={{ marginTop: 8 }}>Il link di verifica non è valido o è scaduto.</p><Link to="/login" className="btn btn-outline" style={{ marginTop: 20, display: 'inline-block' }}>Torna al login</Link></>}
      </div>
    </div>
  );
}

export default LoginPage;
